/** Authoritative route timing for the original anatomical rabbit rig.
 * Geometry and scale are supplied by the scene profile, never by async loading.
 */
export const ORIGINAL_RABBIT_MOTION_PROFILE='original-rabbit-04';
// Includes all whiskers and bounded terrain adaptation around the route root.
export const ORIGINAL_RABBIT_CLEARANCE=.30;
export const ORIGINAL_RABBIT_GAIT=Object.freeze({maximumHopStride:.32,maximumCadence:1.45,advanceStart:.08,advanceDuration:.60,frontLift:.025,frontCatch:.50,frontRecovery:.565,frontFinalPlant:.82,hindLift:.25,hindCatch:2/3});
export function prepareOriginalRabbitAnimal(animal){
 const quarter=animal.route.length*.25,hops=Math.max(3,Math.ceil(quarter/(ORIGINAL_RABBIT_GAIT.maximumHopStride*animal.body.scale))),moveDuration=hops*1.875/ORIGINAL_RABBIT_GAIT.maximumCadence;
 return{...animal,motionProfile:ORIGINAL_RABBIT_MOTION_PROFILE,body:{...animal.body},hopsPerMove:hops,hopStride:quarter/hops,moveDuration,cycleDuration:moveDuration+animal.forageDuration+animal.restDuration};
}
